import BaseService from './base.service';
import { Roles } from '@/constants';

export default class UserService extends BaseService {
  getLocations(role, organizationUuid) {
    let path = 'company/list';

    if (role === Roles.SUPER_ADMIN || role === Roles.CS_ADMIN) {
      path = `super/locations/${organizationUuid}`;
    } else if (role === Roles.ADMIN) {
      path = 'admin/locations';
    }

    return this.get(path);
  }

  /**
   *
   * @param {*} uuid // rental uuid
   * @returns
   */
  uploadPhoto(uuid, data) {
    return this.create(`renter/upload_photo/${uuid}`, data);
  }

  uploadLienTaskPhoto(uuid, data) {
    return this.create(`lien/upload_photo/${uuid}`, data);
  }

  uploadLienTaskPhotoPdf(uuid, data) {
    return this.create(`lien/upload_photo_pdf/${uuid}`, data);
  }

  deleteLienFile(fileId) {
    return this.create(`lien/delete_file/${fileId}`);
  }

  getRenterView(uuid) {
    return this.get(`renter/view/${uuid}`);
  }

  /**
   *
   * @param {*} uuid // rental uuid
   * @returns
   */
  updateRenterStatus(uuid) {
    return this.get(`renter/status/${uuid}`);
  }

  /**
   *
   * @param {*} uuid // lien task uuid
   * @returns
   */
  executeLienTask(uuid) {
    return this.get(`super/executed/${uuid}`);
  }

  getEmployees(organizationUuid) {
    if (organizationUuid) {
      return this.get(`admin/team/${organizationUuid}`);
    }
    return this.get('admin/team/');
  }

  /**
   *
   * @param {*} uuid // mployee uuid
   * @returns
   */
  removeEmployee(uuid) {
    return this.delete(`admin/employee/${uuid}`);
  }

  removeLocation(uuid) {
    return this.delete(`admin/location/${uuid}`);
  }

  addEmployee(organizationUuid, data) {
    if (organizationUuid) {
      return this.create(`team/addEmployee/${organizationUuid}`, data);
    }
    return this.create('team/addEmployee/', data);
  }

  editEmployee(userUuid, data) {
    return this.create(`admin/editEmployee/${userUuid}`, data);
  }

  saveProfile(data) {
    return this.create('admin/company', data);
  }

  saveUser(data) {
    return this.create('admin/user', data);
  }

  updateProfile(data) {
    return this.create('user/update/', data);
  }

  checkRegistrationCode(registerUuid, randomKey) {
    return this.get(`user/check_registration_code/${registerUuid}?random_key=${randomKey}`);
  }

  getStates(organizationUuid) {
    return this.get(`state/list/${organizationUuid}`);
  }

  createState(data, organizationUuid) {
    return this.create(`state/create/${organizationUuid}`, data);
  }

  createTemplate(data) {
    return this.create('super/createtemplate', data);
  }

  createCompany(data) {
    return this.create('company/create', data);
  }

  editState(data, uuid) {
    return this.create(`state/update/${uuid}`, data);
  }

  editCompany(data, uuid) {
    return this.create(`company/update/${uuid}`, data);
  }

  getOrganizations() {
    return this.get('organization/list');
  }

  createOrganization(data) {
    return this.create('organization/create/', data);
  }

  updateOrganization(data, uuid) {
    return this.create(`organization/update/${uuid}`, data);
  }

  discontinuesOrganization(uuid) {
    return this.create(`organization/delete/${uuid}`);
  }

  getAiAdminList() {
    return this.get('super/list');
  }

  createAiAdmin(data) {
    return this.create('super/create', data);
  }

  deleteAiAdmin(uuid) {
    return this.delete(`super/admin/${uuid}`);
  }

  getAdminList(organizationUuid) {
    return this.get(`admin/list/${organizationUuid}`);
  }

  getCsAdminList(organizationUuid) {
    return this.get(`admin/listcs/${organizationUuid}`);
  }

  createAdmin(data, organizationUuid) {
    return this.create(`admin/create/${organizationUuid}`, data);
  }

  createAdmincs(data) {
    return this.create('admin/createcs', data);
  }

  updateAdmincs(data, uuid) {
    return this.create(`admin/updatecs/${uuid}`, data);
  }

  deleteAdmin(uuid) {
    return this.delete(`admin/admin/${uuid}`);
  }

  deleteAdmincs(uuid) {
    return this.delete(`admin/admincs/${uuid}`);
  }

  getRenterHistory(uuid) {
    return this.get(`renter/history/${uuid}`);
  }

  updateUserHoldPermissions(data, uuid) {
    return this.create(`user/permissions/${uuid}`, data);
  }

  getUserHoldPermissions(uuid) {
    return this.get(`user/permissions/${uuid}`);
  }

  getRenterHistoryUpdates(uuid) {
    return this.get(`renter/activity/${uuid}`);
  }

  getRenterFile(uuid) {
    return this.get(`renter/lienView/${uuid}`);
  }

  getZendeskFaqLink() {
    return this.get('zendesk/faq_link/');
  }

  getZendeskHelpCenterLink() {
    return this.get('zendesk/helpdesk_link/');
  }
}
